module.exports = __webpack_public_path__ + "img/home--advantage@2x.d43d43bd.jpg";